import { useIntl } from '@capsicum/common';
import { CheckboxInput, Tooltip } from '@capsicum/common-web';
import { InfoIcon } from '@capsicum/common-web/icons';
import styled, { useTheme } from 'styled-components';

import { CheckboxText } from './Register.styled';

export const AgeConfirmation = () => {
	const { $t } = useIntl();
	const { colors } = useTheme();

	return (
		<S.AgeConfirmationSection>
			<CheckboxInput name="isAbove18" testID="registration-age-confirmation-checkbox">
				<CheckboxText>{$t('auth.registration.emailStep.ageConfirmation')}</CheckboxText>
			</CheckboxInput>

			<Tooltip>
				<Tooltip.Trigger testID="registration-age-confirmation-tooltip">
					<S.TooltipIcon color={colors.icons.info.enabled} height="20" width="20" />
				</Tooltip.Trigger>

				<Tooltip.Content>
					<Tooltip.Description>
						{$t('auth.registration.emailStep.ageConfirmationTooltip')}
					</Tooltip.Description>
				</Tooltip.Content>
			</Tooltip>
		</S.AgeConfirmationSection>
	);
};

namespace S {
	export const AgeConfirmationSection = styled.div`
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const TooltipIcon = styled(InfoIcon)`
		margin-top: ${({ theme }) => theme.spacings.xxxxsmall};
	`;
}
